import React from 'react';
import { AuthenticationCheck } from '@jira/spa-apps__common/src/AuthenticationCheck.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import RouteWrapperHealthcheckPage from './HealthcheckPageConnected.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const HealthcheckPage = (props: Record<any, any>): React.JSX.Element => (
	<UFOSegment name="applinks-extra-auth-healthcheck-page">
		<AuthenticationCheck>
			<RouteWrapperHealthcheckPage {...props} />
			<SpaStatePageReady />
		</AuthenticationCheck>
	</UFOSegment>
);

export default HealthcheckPage;
